import type { ParsedQs } from 'qs'

type QueryParam = ParsedQs[string]

/** Returns the param, if it's a string. */
export function stringParam(v: QueryParam): string | undefined {
  return typeof v === 'string' ? v : undefined
}
